import {isLoggedIn} from 'utils/auth'

export default (store) => ({
  path: 'parallel-upload',
  onEnter: isLoggedIn(store),
  getComponent(nextState, callback) {
    require.ensure([], (require) => {
      const component = require('./ParallelUpload').default
      callback(null, component)
    }, 'ParallelUpload')
  }
})



// WEBPACK FOOTER //
// ./src/routes/rule-ui-routes/ParallelUpload/index.js